<template>
  <div class="latest-order-card">
    <div class="border">
      <span class="img-style">
        <img
          :src="
            require(`@/assets/images/${getServiceIcon(
              orderData.order.product.productId
            )}`)
          "
        />
      </span>
      <span class="text-tile">
        <p class="small">
          {{ formatDate(orderData.order.orderDate) }}
        </p>
        <p class="order-name">
          {{ orderData.order.name || orderData.order.product.productType }}
        </p>
        <p class="order-id">{{ orderData.order.cartId }}</p>
        <div class="parent">
          <span class="child">
            <pn-icon
              :symbol="statuses[orderData.order.status].symbol"
              :color="statuses[orderData.order.status].background"
              size="medium"
              solid
            >
            </pn-icon>
            {{ $t(statuses[orderData.order.status].text) }}
          </span>
        </div>
      </span>
    </div>
  </div>
</template>

<script>
import * as utils from '@/helpers/utilHelper.js'
import orderDetails from '@/components/order-details-modal/orderDetails.json'

export default {
  name: 'LatestOrdersCardComponent',
  props: {
    orderData: Object
  },
  data() {
    return {
      statuses: orderDetails.statuses
    }
  },
  methods: {
    formatDate: utils.formatDate,
    getServiceIcon(productId) {
      if (productId) {
        switch (productId) {
          case '1000' || '2000' || '3000' || '4000' || '5000':
            return 'circle-letter.svg'
          case '6000':
            return 'circle-postcard.svg'
          case '7000':
            return 'circle-flyer.svg'
          case '8000':
            return 'circle-flyer.svg'
          default:
            return 'circle-letter.svg'
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.border:hover {
  background: $blue50;
  border-color: $blue700;
}

.border:active {
  background: $blue900;

  h2,
  p {
    color: white;
  }
}

.border {
  border: 0.01em solid $gray200;
  display: flex;
  cursor: pointer;
  margin-bottom: 2em;
  padding-top: 2em;
  margin-right: 2em;
  width: 45%;
  float: left;
}

.small {
  color: $gray700;
  margin-bottom: 0.5em;
}

.order-name {
  color: $black;
  font-weight: 600;
  margin-bottom: 0.25em;
}

.order-id {
  color: $blue700;
  margin-bottom: 0.625em;
}

.parent {
  display: table;
}

.child {
  display: table-cell;
  vertical-align: middle;
  padding-bottom: 1.5em;
}

.img-style {
  float: left;
  margin-top: 1em;
  margin-right: 0.8em;
  margin-left: 1em;

  img {
    width: 5em;
    height: 5em;
  }
}

.text-tile {
  display: flex;
  flex-direction: column;
  margin: 1.5em;
}

@media screen and (max-width: 75em) {
  .border {
    width: 100%;
  }

  .img-style {
    margin-right: 0;
    margin-left: 0.4em;
    margin-top: 2em;
  }
}

@media screen and (max-width: 50em) {
  .border {
    width: 100%;
  }
}
</style>
